module.exports = __webpack_public_path__ + "static/media/Santacruz.290c2c0c.svg";